export const getOpenGraphLocaleFormatter = () => {
  const format = (locale: MaybeRef<AvailableLocaleCodes>) => {
    const splitted = toValue(locale).split('-')
    return `${splitted[0].toLocaleLowerCase()}_${splitted[splitted.length - 1].toUpperCase()}`
  }
  return { format }
}
